const styles = ({ FONT_SIZES, COLORS }) => ({
  container: {
    listStyle: 'none',
    padding: '0',
    margin: '0',
    display: 'flex',
    flexDirection: 'row',
    fontSize: '16px',
    '& li': {
      padding: '0 0 0 40px',
      position: 'relative',
      '&:after': {
        content: '""',
        width: '5px',
        height: '5px',
        borderRadius: '100%',
        backgroundColor: '#DDDDDD',
        position: 'absolute',
        left: '18px',
        top: '7px'
      },
      '&:first-child': {
        padding: '0',
        '&:after': {
          display: 'none'
        }
      }
    }
  },
  title: {
    fontWeight: 'bold',
    margin: '0 5px 0'
  },
  firstGroup: {
    color: COLORS.TEXT.DARK_GREY.NORMAL
  },
  otherGroups: {
    margin: '0 0 0 5px',
    color: COLORS.TEXT.DARK_GREY.NORMAL
  },
  actionLink: {
    color: COLORS.BLUE.NORMAL,
    cursor: 'pointer'
  }
})

export default styles
